import { render, staticRenderFns } from "./AdminParamsPage.vue?vue&type=template&id=6e4ac6a8"
import script from "./AdminParamsPage.vue?vue&type=script&lang=js"
export * from "./AdminParamsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports